import JinongTrade from './jinong-trade/jinong-trade.vue';
import MarketMemberList from './market-member-list/market-member-list.vue';
import MarketMemberDetail from './market-member-detail/market-member-detail.vue';
export default [
  {
    path: 'jinong-trade',
    name: 'jinongTrade',
    component: JinongTrade,
    meta: {
      title: '田东产权',
      breadCrumbShowIndexArr: [0, 2, 1]  // 面包屑
    }
  },
  {
    path: 'market-member-list',
    name: 'marketMemberList',
    component: MarketMemberList,
    meta: {
      title: '合作伙伴',
      breadCrumbShowIndexArr: [0, 1, 2]  // 面包屑
    }
  },
  {
    path: 'market-member-detail',
    name: 'marketMemberDetail',
    component: MarketMemberDetail,
    meta: {
      title: '合作伙伴详情',
      breadCrumbShowIndexArr: [0, 1, 2]  // 面包屑
    }
  }
];
